var app;

app = window.App || (window.App = {});

app.NavOffCanvas = {
  toggle: function(e) {
    e.preventDefault();
    return $('.nav-left').toggleClass("is-visible");
  }
};

$(document).on('click', '.toggle-nav', app.NavOffCanvas.toggle);

$(document).on('click', '.nav-left-overlay', app.NavOffCanvas.toggle);

$(document).keyup(function(e) {
  if ((e.key === 'Escape') && $('.nav-left').hasClass('is-visible')) {
    return app.NavOffCanvas.toggle(e);
  }
});
